import { EmplacementData } from "../Types";
import * as FP from "./FormPaths";

export const DEFAULT_ZONE = "Zone";
export const DEFAULT_LOCAL = "Local";
export const DEFAULT_FLOOR = "Stairs";
export const DEFAULT_ICON_SHOP = "Shop";
export const DEFAULT_ICON_SITE = "Default Site";
export const DEFAULT_ICON_BUILD = "Default Build";
export const DEFAULT_ICON_CLIENT = "Default Client";
export const DEFAULT_ICON_ENTITY = "Default Entity";

export const FA_ICONS = {
    [FP.EQUIPEMENT_FORM]: "cog",
    [FP.SITE_FORM]: "city",
    [FP.BUILDING_FORM]: "building",
    [FP.CLIENT_FORM]: "user",
    [FP.EMPLACEMENT_FORM]: "stairs",
}

export const EMPLACEMENT_ICONS: Record<EmplacementData["type"], string> = {
    floor: "stairs",
    local: "square",
    zone: "square",
    parking: "parking",
}